import React from 'react';
import { Outlet } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AuthLayout: React.FC = () => {
  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Row className="w-100">
        <Col md={8} lg={6} className="mx-auto">
          <Card className="shadow">
            <Card.Body className="p-5">
              <div className="text-center mb-4">
                <Link to="/" className="text-decoration-none">
                  <h2>AutoFill</h2>
                </Link>
                <p className="text-muted">Войдите в свой аккаунт</p>
              </div>
              <Outlet />
              <div className="text-center mt-4">
                <p className="mb-0">
                  <Link to="/auth/register" className="text-decoration-none">
                    Создать аккаунт
                  </Link>
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AuthLayout;
